import React from 'react';

import { SVGPropsType } from 'src/types';

const CrossCircleSmall = (props: SVGPropsType) => {
    const { fill, onClick, style, className } = props;
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.86872 4.63128C5.52701 4.28957 4.97299 4.28957 4.63128 4.63128C4.28957 4.97299 4.28957 5.52701 4.63128 5.86872L5.76256 7L4.63128 8.13128C4.28957 8.47299 4.28957 9.02701 4.63128 9.36872C4.97299 9.71043 5.52701 9.71043 5.86872 9.36872L7 8.23744L8.13128 9.36872C8.47299 9.71043 9.02701 9.71043 9.36872 9.36872C9.71043 9.02701 9.71043 8.47299 9.36872 8.13128L8.23744 7L9.36872 5.86872C9.71043 5.52701 9.71043 4.97299 9.36872 4.63128C9.02701 4.28957 8.47299 4.28957 8.13128 4.63128L7 5.76256L5.86872 4.63128Z"
                fill={fill}
            />
        </svg>
    );
};
export default CrossCircleSmall;
